import PropTypes from 'prop-types';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

import { menuStyles } from './menuStyles';

export const MenuPanel = ({ options }) => {
  return (
    <List disablePadding>
      {options.map(({ key, label, icon, endSlot, selected, disabled, onClick }) => (
        <ListItem divider disablePadding key={key} sx={menuStyles.item}>
          <ListItemButton disableRipple selected={!!selected} disabled={!!disabled} onClick={onClick}>
            {icon && <ListItemIcon>{icon}</ListItemIcon>}

            <ListItemText primary={label} />

            {endSlot}
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

MenuPanel.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node.isRequired,
      icon: PropTypes.node,
      endSlot: PropTypes.node,
      selected: PropTypes.bool,
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
    }),
  ).isRequired,
};
